export const COMMON_AGENT_MESSAGES = {
  tryAgain:
    'Sorry, there was an error processing your message. Please try again.',
  couldNotProcess: "I apologize, but I couldn't process that request.",
  greeting: 'Hi! What can I help you with?',
};
